/*
	Simple ErrorBoundary that just logs the error to the console and has a minimal
	fallback element.

	We can change this to log to Sentry or whatever we want, depending on the environment.
*/

import React from "react";

export default class SimpleErrorBoundary extends React.Component{
	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return {
			hasError: true,
		};
	}

	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
		};
	}

	componentDidCatch(error, errorInfo) {
		console.error("Caught by SimpleErrorBoundary:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<span>Something broke :(</span>
			);
		}

		return this.props.children;
	}
}
